import React, { useState } from 'react'
import { Popup, Toast } from 'antd-mobile'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import API_ROUTES from '../../../api'
// 请假原因与管理员编辑报名时共用，避免两处可选原因不一致。
import { LEAVE_REASONS } from '../model/leaveReasons'
import './registrationActions.css'

const roleOptions = [
    { value: 0, icon: '⚽', label: '上场球员' },
    { value: 1, icon: '🏁', label: '主裁' },
    { value: 2, icon: '🚩', label: '边裁' },
    { value: 3, icon: '🖥️', label: 'VAR' },
    { value: 4, icon: '👀', label: '观众' },
]
const actionItems = [
    { key: 'signup', label: '报名', icon: '⚽', kind: 'blue' },
    { key: 'leave', label: '请假', icon: '🗓️', kind: 'orange' },
    { key: 'pending', label: '待定', icon: '⏳', kind: 'gray' },
]

export default function RegistrationActions({ gameId, gameType, memberId, currentType, counts, mvpState, onChanged, isAdmin = false, disabled = false, className = '' }) {
    const navigate = useNavigate()
    const [panel, setPanel] = useState(null)
    const [role, setRole] = useState(null)
    const [leaveReason, setLeaveReason] = useState('')
    const [leaveDetail, setLeaveDetail] = useState('')
    const [saving, setSaving] = useState(false)
    const numericType = currentType == null ? null : Number(currentType)
    const signupActive = numericType != null && numericType >= 0 && numericType <= 4
    const isActive = key => key === 'signup' ? signupActive : numericType === (key === 'leave' ? 5 : 6)
    // 上一场参赛而未投票时，只锁定新的内讧赛报名；取消当前状态始终可操作。
    // 管理员代报名不受上一场 MVP 投票限制；普通球员自行报名仍按原规则校验。
    const voteLocked = !isAdmin && Number(gameType) === 3 && !signupActive
        && (mvpState?.checking || (mvpState?.clickInfo && !mvpState?.likeMemberId))
    const cancelling = Boolean(panel && panel !== 'vote' && isActive(panel))
    const currentAction = actionItems.find(item => item.key === panel)

    const openPanel = key => {
        if (disabled || saving) return
        if (key === 'signup' && voteLocked) {
            setPanel('vote')
            return
        }
        setRole(null)
        setLeaveReason('')
        setLeaveDetail('')
        setPanel(key)
    }

    const submit = async () => {
        if (!panel || saving) return
        if (panel === 'vote') {
            if (mvpState?.gameId) {
                setPanel(null)
                navigate(`/games/${mvpState.gameId}/history`)
            } else {
                Toast.show({ icon: 'fail', content: '投票状态暂不可用，请刷新后重试' })
            }
            return
        }
        if (!gameId || !memberId) return Toast.show({ icon: 'fail', content: '球员或比赛信息缺失' })
        if (!cancelling && panel === 'signup' && role == null) return Toast.show({ icon: 'fail', content: '请选择报名身份' })
        if (!cancelling && panel === 'leave' && !leaveReason && !leaveDetail.trim()) return Toast.show({ icon: 'fail', content: '请选择或填写请假原因' })

        setSaving(true)
        try {
            const response = cancelling
                ? await axios.post(API_ROUTES.game_cancelRegistration, null, { params: { gameId } })
                : await axios.post(API_ROUTES.game_join, {
                    gameId,
                    memberId,
                    gameType: panel === 'signup' ? role : panel === 'leave' ? 5 : 6,
                    remark: panel === 'leave' ? [leaveReason, leaveDetail.trim()].filter(Boolean).join('：') : null,
                })
            if (response.data?.code !== 200) throw new Error(response.data?.msg || '操作失败')
            const message = cancelling ? `已取消${currentAction.label}` : `${currentAction.label}成功`
            setPanel(null)
            // 刷新首页或详情页人数与本人状态；刷新失败不改变本次操作的成功结果。
            try { await onChanged?.() } catch (_) { /* 页面仍可手动刷新。 */ }
            Toast.show({ icon: 'success', content: message })
        } catch (error) {
            Toast.show({ icon: 'fail', content: error?.response?.data?.msg || error?.message || '操作失败，请重试' })
        } finally {
            setSaving(false)
        }
    }

    return <>
        <div className={`match-reg-actions ${className}`}>
            {actionItems.map(item => {
                const active = isActive(item.key)
                const locked = item.key === 'signup' && voteLocked && !active
                return <button
                    key={item.key}
                    type="button"
                    className={`match-reg-card match-reg-card--${item.kind} ${active ? 'is-active' : ''} ${locked ? 'is-locked' : ''}`}
                    onClick={() => openPanel(item.key)}
                    disabled={disabled || saving}
                    aria-pressed={active}
                    aria-label={active ? `取消${item.label}，当前${Number(counts?.[item.key] || 0)}人` : locked ? `报名需先完成 MVP 投票，当前${Number(counts?.[item.key] || 0)}人` : `${item.label}，当前${Number(counts?.[item.key] || 0)}人`}
                >
                    {/* 卡片只保留图标、人数和操作名称，选中状态用勾选标记表达。 */}
                    <span className="match-reg-card-top">
                        <span className="match-reg-card-icon" aria-hidden="true">{item.icon}</span>
                        {active && <span className="match-reg-card-check" aria-hidden="true">✓</span>}
                    </span>
                    <span className="match-reg-card-bottom">
                        <span className="match-reg-card-title">{item.label}</span>
                        <strong className="match-reg-card-count">{Number(counts?.[item.key] || 0)}<small>人</small></strong>
                    </span>
                </button>
            })}
        </div>
        <Popup visible={Boolean(panel)} position="bottom" bodyClassName="match-reg-popup" onMaskClick={() => !saving && setPanel(null)}>
            <div className="match-reg-sheet">
                <div className="match-reg-sheet-grip" />
                <div className="match-reg-sheet-heading">
                    <span className="match-reg-sheet-icon">{panel === 'vote' ? '🏆' : currentAction?.icon}</span>
                    <div><strong>{panel === 'vote' ? '先完成 MVP 投票' : cancelling ? `取消${currentAction?.label}` : panel === 'signup' ? '选择报名身份' : panel === 'leave' ? '请假报备' : '设置待定状态'}</strong>
                        <small>{panel === 'vote' ? '投票后即可报名本场内讧赛' : cancelling ? '取消后将从本场名单中移除' : '本场比赛 · 请选择你的状态'}</small></div>
                </div>
                {panel === 'vote' && <p className="match-reg-sheet-text">{mvpState?.checking ? '正在确认上一场内讧赛投票状态，请稍后刷新。' : '你参加了上一场内讧赛，完成 MVP 投票后才能继续报名。'}</p>}
                {cancelling && <p className="match-reg-sheet-text">确认后会删除你在本场比赛的{currentAction?.label}记录。如有需要，可以重新选择状态。</p>}
                {!cancelling && panel === 'signup' && <div className="match-reg-role-list">{roleOptions.map(option => <button key={option.value} type="button" className={role === option.value ? 'selected' : ''} onClick={() => setRole(option.value)}><span>{option.icon}</span>{option.label}<b>{role === option.value ? '✓' : ''}</b></button>)}</div>}
                {!cancelling && panel === 'leave' && <div className="match-reg-leave-fields"><div className="match-reg-field-label">请假原因</div><div className="match-reg-reasons">{LEAVE_REASONS.map(reason => <button key={reason.value} type="button" className={leaveReason === reason.value ? 'selected' : ''} onClick={() => setLeaveReason(reason.value)}>{reason.label}</button>)}</div><input value={leaveDetail} onChange={event => setLeaveDetail(event.target.value)} placeholder="补充说明（选填）" aria-label="请假补充说明" /></div>}
                {!cancelling && panel === 'pending' && <p className="match-reg-sheet-text">还不确定能否参加？先选择待定，确定后可以再改为报名或请假。</p>}
                <div className="match-reg-sheet-actions">
                    <button type="button" className="match-reg-secondary" disabled={saving} onClick={() => setPanel(null)}>返回</button>
                    <button type="button" className={`match-reg-primary ${cancelling ? 'is-danger' : ''}`} disabled={saving || (panel === 'vote' && !mvpState?.gameId)} onClick={submit}>{saving ? '处理中…' : panel === 'vote' ? '去投票' : cancelling ? `确认取消${currentAction?.label}` : `确认${currentAction?.label}`}</button>
                </div>
            </div>
        </Popup>
    </>
}
